export default function Pagination({
	currentPage,
	setCurrentPage,
	totalPages,
}: {
	currentPage: number;
	setCurrentPage: (page: number) => void;
	totalPages: number;
}) {
	return totalPages > 1 ? (
		<div className="flex justify-center">
			<div className="inline-flex mt-2 xs:mt-0">
				{currentPage > 1 && (
					<button
						type="button"
						onClick={() => setCurrentPage(currentPage - 1)}
						className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
					>
						<span className="sr-only">Previous</span>
						<svg
							className="h-5 w-5"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
							fill="currentColor"
							aria-hidden="true"
						>
							<path
								fillRule="evenodd"
								d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
								clipRule="evenodd"
							/>
						</svg>
					</button>
				)}
				<div className="relative inline-flex items-center px-2 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-500">{`${currentPage} of ${totalPages}`}</div>
				{currentPage < totalPages && (
					<button
						type="button"
						onClick={() => setCurrentPage(currentPage + 1)}
						className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
					>
						<span className="sr-only">Next</span>
						<svg
							className="h-5 w-5"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
							fill="currentColor"
							aria-hidden="true"
						>
							<path
								fillRule="evenodd"
								d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
								clipRule="evenodd"
							/>
						</svg>
					</button>
				)}
			</div>
		</div>
	) : null;
}
